import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './SearchCars.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import SearchCarsSection from "../Components/SearchCarsSection";
import audiLogo from "./assets/Logos/logo_audi.png";
import alfaLogo from "./assets/Logos/alfa_logo.jpg";
import bentleyLogo from "./assets/Logos/bentley_Logo.png";
import chryslerLogo from "./assets/Logos/chrysler_Logo.png";
import renaultLogo from "./assets/Logos/renault_logo.jpg";
import hondaLogo from "./assets/Logos/logo_honda.png";
import subaruLogo from "./assets/Logos/logo_subaru.png";
import toyotaLogo from "./assets/Logos/logo_toyota.png";
import nissanLogo from "./assets/Logos/logo_nissan.png";
import isuzuLogo from "./assets/Logos/logo_isuzu.png";
import mitsubishiLogo from "./assets/Logos/logo_mitsubishi.png";
import bmwLogo from "./assets/Logos/logo_bmw.png";
import mazdaLogo from "./assets/Logos/logo_mazda.png";
import suzukiLogo from "./assets/Logos/logo_suzuki.png";
import mercedesLogo from "./assets/Logos/logo_mercedes.png";
import hinoLogo from "./assets/Logos/logo_hino.png";
import hyundaiLogo from "./assets/Logos/logo_hyundai.png";
import daihatsuLogo from "./assets/Logos/logo_daihatsu.png";
import fordLogo from "./assets/Logos/logo_ford.png";
import jaguarLogo from "./assets/Logos/logo_jaguar.png";
import jeepLogo from "./assets/Logos/logo_jeep.png";
import kiaLogo from "./assets/Logos/logo_kia.png";
import landroverLogo from "./assets/Logos/logo_land-rover.png";
import lexusLogo from "./assets/Logos/logo_lexus.png";
import peugeotLogo from "./assets/Logos/logo_peugeot.png";
import volvoLogo from "./assets/Logos/logo_volvo.png";
import volkswagenLogo from "./assets/Logos/logo_volkswagen.png";
import PorscheLogo from "./assets/Logos/PorscheLogo.png";
import miniLogo from "./assets/Logos/mini_logo.png";
import lotuslogo from "./assets/Logos/lotus_logo.jpg";
import mcLarenLogo from "./assets/Logos/McLaren_logo.jpg";
import fiatLogo from "./assets/Logos/fiat_logo.jpg";
import ferrariLogo from "./assets/Logos/ferrari-logo.jpg";
import maseratiLogo from "./assets/Logos/maserati_logo.png";
import lamborghiniLogo from "./assets/Logos/lamborghini_logo.png";
import citroenLogo from "./assets/Logos/citroen_logo.png";
import teslaLogo from "./assets/Logos/tesla_logo.jpg";
import mitsuokalogo from "./assets/Logos/mitsuoka_logo.png";
import chevroletLogo from "./assets/Logos/chevrolet_logo.png";
import mccsmartLogo from "./assets/Logos/Smart-Emblem.png";
import RollsRoyceLogo from "./assets/Logos/Rolls-Royce-Logo.jpg";
import dodgeLogo from "./assets/Logos/dodge_logo.png";

const makerLogos = {
  audi: audiLogo,
  alfa: alfaLogo,
  bentley: bentleyLogo,
  chrysler: chryslerLogo,
  renault: renaultLogo,
  honda: hondaLogo,
  subaru: subaruLogo,
  toyota: toyotaLogo,
  nissan: nissanLogo,
  isuzu: isuzuLogo,
  mitsubishi: mitsubishiLogo,
  bmw: bmwLogo,
  mazda: mazdaLogo,
  suzuki: suzukiLogo,
  mercedes_benz: mercedesLogo,
  hino: hinoLogo,
  daihatsu: daihatsuLogo,
  hyundai: hyundaiLogo,
  ford: fordLogo,
  jaguar: jaguarLogo,
  jeep: jeepLogo,
  kia: kiaLogo,
  landrover: landroverLogo,
  land_rover: landroverLogo,
  lexus: lexusLogo,
  peugeo: peugeotLogo,
  volvo: volvoLogo,
  volkswagen: volkswagenLogo,
  volk_swagen: volkswagenLogo,
  porsche: PorscheLogo,
  mini: miniLogo,
  lotus: lotuslogo,
  mcLaren: mcLarenLogo,
  mclaren: mcLarenLogo,
  fiat: fiatLogo,
  ferrari: ferrariLogo,
  maserati: maseratiLogo,
  lamborghini: lamborghiniLogo,
  citroen: citroenLogo,
  tesla: teslaLogo,
  peugeot: peugeotLogo,
  mitsuoka: mitsuokalogo,
  chevrolet: chevroletLogo,
  mcc_smart: mccsmartLogo,
  rolls_royce: RollsRoyceLogo,
  rollsroyce: RollsRoyceLogo,
  dodge: dodgeLogo,
  
};

const SearchCarsHome = () => {
    const [cars, setCars] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const navigate = useNavigate();
    useEffect(() => {
        fetch('https://api.mitradingjp.com/get-car-search.php')
            .then(response => response.json())
            .then(data => {
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);
    const handleViewVehicle = (carId) => {
        navigate(`/${carId}`);
    };
    
    // Calculate the current items to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cars.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
   const paginate = (pageNumber) => setCurrentPage(pageNumber);
   const normalizeMaker = (maker) =>
   maker?.toLowerCase().trim().replace(/\s+/g, "_");

    const makerMap = {};
    cars.forEach((car) => {
    const key = normalizeMaker(car.maker);
    if (!key) return;

    if (!makerMap[key]) {
        makerMap[key] = {
        maker: car.maker.trim(),
        image: car.images,
        total: 1,
        };
    } else {
        makerMap[key].total += 1;
    }
    });
const makers = Object.values(makerMap);
console.log(makers);

const priorityMakers = [
  "toyota",
  "honda",
  "suzuki",
  "mitsubishi",
  "mazda",
  "nissan",
  "subaru",
  "daihatsu",
  "bmw",
  "mercedes",
  "mercedes_benz",
  "lexus",
  "audi",
  "hino",
  "isuzu",
];

const sortedMakers = [...makers].sort((a, b) => {
  const aKey = normalizeMaker(a.maker);
  const bKey = normalizeMaker(b.maker);
  const aIndex = priorityMakers.indexOf(aKey);
  const bIndex = priorityMakers.indexOf(bKey);
  if (aIndex !== -1 && bIndex !== -1) {
    return aIndex - bIndex;
  }
  if (aIndex !== -1) return -1;
  if (bIndex !== -1) return 1;
  return aKey.localeCompare(bKey);
});

    return (
        <>
            <div className="row">
                {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12 middlecol">
                    <hr className="title-line"></hr>
                    <div className="container">
                        <div className="row">
                            {sortedMakers.map((item) => {
                                const key = normalizeMaker(item.maker);
                                return (
                                <div className="col-md-2 my-2 col-sm-6 col-6" key={key}>
                                    <div className="car-card py-2 text-center" id="logosearch">
                                        <div className="car-category-image">
                                        <img
                                            src={makerLogos[key] || `https://api.mitradingjp.com/${item.image}`}
                                            alt={item.maker}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleViewVehicle(item.maker)}
                                        />
                                        </div>
                                        <div className="car-category-info">
                                        <h5>{item.maker}</h5>
                                        <p>Total Cars: ({item.total})</p>
                                        </div>
                                    </div>
                                </div>
                                );
                            })}
                        </div>
                    </div>    
                    <hr className="title-line"></hr>
                    {/* Pagination */}
                    <div className="pagination d-none">
                        {Array.from({ length: Math.ceil(cars.length / itemsPerPage) }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={currentPage === i + 1 ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchCarsHome;